import { HashRouter, useLocation, useSearchParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// routes
import Router from './routes';
// theme

// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import { useEffect,useState } from 'react';
import axios from 'axios';
import { LocalizationProvider } from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import 'moment/locale/fr';

export default function App() {
 
 
  const [VerifyIp,setVerifyIP]=useState(null)
  useEffect(()=>{
    var tmpStr = window.location.toString()
   const query = window.location.search;
   if(query.includes('?key=') && !tmpStr.includes("#/customer?key") ){
        console.log(window.location.origin)
        window.location = `${window.location.origin}#/customer${query}`;
   }
   else{
    axios.get("https://api.ipify.org/?format=json").then(data=>{
      if(data.data.ip==="91.183.212.212" || tmpStr.includes("#/customer?key")){
        setVerifyIP(true)
      }
      else{
        
        setVerifyIP(false)
      }
    }).catch(e=>
      axios.get('https://checkip.amazonaws.com/').then(e=>{console.log(e);e.data==='91.183.212.212\n'?setVerifyIP(true):setVerifyIP(false)})
    )
  }
 },[])


  return (
    VerifyIp?
    <HelmetProvider>
      <HashRouter>
      
          <ScrollToTop />
          <StyledChart />
          <LocalizationProvider adapterLocale='fr' dateAdapter={AdapterMoment}>
          <Router />
         </LocalizationProvider>
        
      
      </HashRouter>
    </HelmetProvider>
      :
      VerifyIp===null?
      <div><h1>Vérification en cours ...</h1></div>
      :
      <div><h1>Accès refusé depuis votre emplacement</h1></div>
  );
}
